class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.dataset.lnModalReady = String(this.canEnhance());

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  canEnhance() {
    return typeof trapFocus === 'function' && typeof removeTrapFocus === 'function';
  }

  onSummaryClick(event) {
    this.dataset.lnModalReady = String(this.canEnhance());
    if (!this.canEnhance()) return;
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    if (!this.canEnhance()) {
      this.detailsContainer.setAttribute('open', '');
      return;
    }
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.header = this.closest('.section-header');
    this.header?.querySelectorAll('header-drawer').forEach((drawer) => drawer.closeMenuDrawer());
    this.header?.classList.remove('shopify-section-header-hidden', 'animate');
    this.header?.classList.add('search-open');
    this.detailsContainer.setAttribute('open', '');
    this.summaryToggle.setAttribute('aria-expanded', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;
    this.querySelectorAll('predictive-search').forEach((search) => search.close?.());
    if (typeof removeTrapFocus === 'function' &&
        (typeof trapFocusHandlers === 'undefined' || !trapFocusHandlers.container || this.contains(trapFocusHandlers.container))) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }
    this.detailsContainer.removeAttribute('open');
    this.summaryToggle.setAttribute('aria-expanded', false);
    this.header?.classList.remove('search-open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    // Another modal may have taken over while this header was being removed.
    if (!document.querySelector('cart-drawer.active, modal-dialog[open], product-modal[open], quick-add-modal[open], details-modal > details[open]')) {
      document.body.classList.remove('overflow-hidden');
    }
  }
  disconnectedCallback() {
    this.close(false);
  }
}

customElements.define('details-modal', DetailsModal);
